app.service("nodeTree", function(html) {
	var $self;
	function setElements(){
		$self=$("#node-tree");
	}
	function setEvents(){
		$self.menuMultilevel();
	}
	function init() {
		setElements();
		setEvents();
	}
	
	return {
		init: init
	};
});